// export const password = "5olusipay";
// export const respassword = "s0lusipay";
// export const regexp = /^[0-9a-zA-Z/\b]+$/;
// export const regexpamount = /^$|^[1-9][0-9]{0,9}$/;
// export const regexpnumber = /^[0-9]+$/;
const CryptoJS = require("crypto-js");

export function hmac256(message: string = "", key: string = ""): string {
  // console.log("message in hmac256:", message);
  // console.log("key in hmac256:", key);
  // console.log(
  //   "key in hmac256 hex:",
  //   CryptoJS.HmacSHA256(message, key).toString(CryptoJS.enc.Hex)
  // );

  return CryptoJS.HmacSHA256(message, key).toString(CryptoJS.enc.Base64);
}

export const currencyMap: { [key: string]: string } = {
  IDR: "id-ID", // Indonesian Rupiah
  USD: "en-US", // US Dollar
  SGD: "en-SG", // Singapore Dollar
  MYR: "ms-MY", // Malaysian Ringgit
  THB: "th-TH", // Thai Baht
  VND: "vi-VN", // Vietnamese Dong
  PHP: "en-PH", // Philippine Peso
  KRW: "ko-KR", // South Korean Won
  JPY: "ja-JP", // Japanese Yen
  CNY: "zh-CN", // Chinese Yuan
  HKD: "zh-HK", // Hong Kong Dollar
  AUD: "en-AU", // Australian Dollar
  NZD: "en-NZ", // New Zealand Dollar
};

export interface FormatCurrencyProps {
  value: any; // Ensure value is either a string or number
  currency?: string; // Optional currency code (defaults to "IDR")
}

export const FormatCurrency = ({ value, currency = 'IDR'}: FormatCurrencyProps) => {
  const numericValue = typeof value === 'string' ? parseFloat(value) : value;

  if (isNaN(numericValue)) {
    return <>{`Invalid value: ${value}`}</>;
  }

  const formattedValue = new Intl.NumberFormat(currencyMap[currency], {
    style: 'currency',
    currency: currency,
  }).format(numericValue).toString();

  return <>{formattedValue}</>;
};

interface PaymentStatusInfo {
  id: string;
  ket: string;
  bg: string;
}
export const paymentStatusMap: { [key: string]: PaymentStatusInfo } = {
  "Waiting Payment": {
    id: "0",
    ket: "invoice_status_waiting_payment",
    bg: "#ED6C02",
  },
  Paid: {
    id: "1",
    ket: "invoice_status_paid",
    bg: "#286353",
  },
  Overdue: {
    id: "2",
    ket: "invoice_status_overdue",
    bg: "#D32F2F",
  },
};

export const otherFee: { [key: string]: any } = {
  "Biaya Admin": {
    ket: "admin_fee",
  },
  "Admin Fee": {
    ket: "admin_fee",
  },
};

